<template>
  <div class="bg-do-aluno" id="bg-do-aluno">
    <CubeLoad v-if="isLoading"></CubeLoad>
    <v-app-bar
      app
      color="primary"
      dark
      style="margin: 0 auto; box-shadow: none;"
      class="app-bar-style"
    >
      <v-btn @click.stop="drawer = !drawer" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <img src="@/assets_aluno/logotipo_cem_branco2.svg" class="logo-navbar" />
    </v-app-bar>
    <StudentsDrawer
      @close="drawer = false"
      :visibility="drawer"
    ></StudentsDrawer>
    <!-- ######################################## -->
    <!-- row do perfilzinho superior do aluno -->
    <!-- ######################################## -->
    <div v-show="!selectedSubject && !isHomeSchool">
      <ProfileHeader
        v-if="userProfile"
        :profile="userProfile"
        class="profile-header-style fade-in-top"
      />
      <Banner v-if="false" />
      <v-select
        v-show="false"
        v-model="affiliate"
        :items="affiliates"
        :menu-props="{ maxHeight: '400' }"
        label="Filial"
        item-text="name"
        item-value="id"
        solo
        readonly
      ></v-select>
    </div>
    <div v-if="!selectedSubject && !isHomeSchool">
      <ScheduledClassesCards
        @view-class="openScheduledClass"
        :scheduled-classes="scheduledClasses"
        :free-times="freeTimes"
        :classrooms="findClassroom"
        class="fade-in-top animation-delay-2"
      />
      <v-row class="little-title-with-lines-row no-gutters">
        <v-col class="little-title-with-lines-line"></v-col>
        <div class="little-title-with-lines-title">Marcar aulas</div>
        <v-col class="little-title-with-lines-line"></v-col>
      </v-row>
      <SubjectsList
        v-if="affiliate"
        :subjects="subjects"
        class="fade-in-top animation-delay-3"
        subtitle="no cem"
      />
      <SubjectsList
        class="fade-in-top animation-delay-3"
        subtitle="em casa"
        :subjects="subjects"
        type="home"
        @positive="selectHomesSchool"
      />
    </div>


    <div class="px-4">
      <v-btn
        class="mt-5 mt-sm-10 px-5"
        v-show="selectedSubject"
        color="#FFFFFF"
        rounded
        outlined
        small
        @click="clearSubject"
      >
        <v-icon color="#FFFFFF" small>mdi-arrow-left</v-icon>
        <span>voltar</span>
      </v-btn>
    </div>


    <Agenda
      class="agenda-style"
      v-if="affiliate && selectedSubject"
      :affiliate-id="affiliate.id"
      :subject="selectedSubject"
    />
    <!-- <HomeSchoolAgenda
      class="agenda-style"
      v-if="isHomeSchool"
      :affiliate-id="affiliate.id"
      :subject="selectedSubject"
    /> -->
    <StudentsProfileDialog
      :visibility="editUser"
      @negative="editUser = !editUser"
      @positive="studentEdit"
      :profile="userProfile"
    />

    {{ scheduled }}
    <ScheduledClassDialog
      v-if="scheduledClassDialog"
      :default-value="scheduledClass"
      @negative="scheduledClassDialog = false"
      @destroy="updateScheduled"
      :visibility="scheduledClassDialog"
      :subject="findSubject(scheduledClass.subject_id)"
    />
    <div class="text-center">
      <v-btn
        class="mt-10 px-5"
        v-show="selectedSubject"
        color="#FFFFFF"
        rounded
        outlined
        @click="clearSubject"
      >
        <v-icon color="#FFFFFF" small>mdi-arrow-left</v-icon>
        <span>voltar</span>
      </v-btn>
    </div>
    <HomeSchoolConfirmAddressDialog
      :visibility="homeSchoolDialog"
      @negative="homeSchoolDialog = false"
    ></HomeSchoolConfirmAddressDialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import CubeLoad from "@/components/loading/CubeLoad";
import Agenda from "../components/agenda/index";
import HomeSchoolAgenda from "../components/agenda/HomeSchoolAgenda";
import SubjectsList from "../components/subjects/SubjectsList";
import HomeSchoolList from "../components/subjects/HomeSchoolList";
import ClassroomList from "../components/ClassroomList";
import Banner from "../components/Banner";
import ProfileHeader from "../components/profile/ProfileHeader";
import HomeSchoolConfirmAddressDialog from '@/components/dialogs/HomeSchoolConfirmAddressDialog'

import ScheduledClassesCards from "@/components/ScheduledClassesCards";
import StudentsProfileDialog from "@/components/dialogs/StudentsProfileDialog";
import ScheduledClassDialog from "@/components/dialogs/EditScheduledClassDialog";

import ProfileServiceMixin from "@/mixins/services/ProfileServiceMixin";
import StudentsDrawer from "@/components/drawers/StudentsDrawer";

export default {
  components: {
    StudentsProfileDialog,
    Banner,
    ProfileHeader,
    SubjectsList,
    Agenda,
    ClassroomList,
    ScheduledClassesCards,
    ScheduledClassDialog,
    CubeLoad,
    StudentsDrawer,
    HomeSchoolList,
    HomeSchoolAgenda,
    HomeSchoolConfirmAddressDialog,
  },
  mixins: [ProfileServiceMixin],
  data() {
    return {
      dialog: undefined,
      homeSchoolDialog: undefined,
      dialogConfirmSchedule: undefined,
      scheduledClassDialog: undefined,
      scheduledClass: undefined,
      drawer: undefined,
      editUser: undefined
    };
  },
  computed: {
    ...mapState([
      "affiliates",
      "affiliate",
      "classrooms",
      "subjects",
      "userProfile",
      "isLoading",
      "freeTimes",
      "scheduledClaaffiliates",
      "affiliate",
      "classrooms",
      "subjects",
      "userProfile",
      "isLoading",
      "scheduledClasses",
      "selectedSubject",
      "isHomeSchool",
    ]),
    ...mapActions("professorsModule", ["loadProfessors", "loadFreeTimes"])
  },
  beforeMount() {
    this.$store.dispatch("loadStore");
    this.loadProfessors;
  },
  watch: {
    selectedSubject() {
      this.loadFreeTimes;
      window.scrollTo(0, 0);
    },
    isHomeSchool() {
      this.loadFreeTimes;
      window.scrollTo(0, 0);
    }
  },

  mounted() {
    //this.openScheduledClass()
  },

  methods: {
    ...mapMutations(["clearSubject"]),

    openScheduledClass(scheduled) {
      this.scheduledClass = scheduled;
      this.scheduledClassDialog = true;
    },

    selectHomesSchool(scheduled) {
      this.setHomeSchool(true)
      this.homeSchoolDialog = true;
    },
    findSubject(id) {
      return this.subjects.find(subject => subject.id === id);
    },
    findClassroom(id) {
      return this.classrooms.find(classroom => classroom.id === id);
    },
    updateScheduled() {
      this.$store.dispatch("loadStore");
      this.scheduledClassDialog = false;
    },
    async studentEdit(event) {
      await this.onStudentEdit(event);
      this.editUser = !this.editUser;
    },
    ...mapMutations(["setHomeSchool"])

  }
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:400,700,900&display=swap"); */
*.unselect,
.div-dos-botoes-da-home,
.scheduled-class-card,
.scheduled-classes-row-title,
.logo-navbar,
.textos-do-perfil,
.botao-selecionar-professor,
.titulo-agenda,
.teachers-dialog-item,
.btn-change-date,
.agenda-date,
.schedule-confirmation-dialog-text,
.schedule-confirmation-dialog-text {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.bg-do-aluno {
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  /* max-width: 415px; */
  margin: 0 auto;
  padding-bottom: 90px;
  background: rgba(69, 0, 153, 1);
  background-image: url("../assets/textured-paper.png");
  background-repeat: repeat;
}

.logo-navbar {
  height: 90%;
}

.app-bar-style {
  background: rgba(69, 0, 153, 1);
  background-image: url("../assets/textured-paper.png");
  background-repeat: repeat;
}

.profile-header-style {
  max-width: 500px;
  margin: 0 auto;
}

.agenda-style {
  max-width: 700px;
  margin: 0 auto;
}

.little-title-with-lines-row {
  /* margin-top: 60px; */
  padding: 0 46px 12px;
  max-width: 540px;
  margin-left: auto;
  margin-right: auto;
}

.little-title-with-lines-line {
  border-top: 1px solid #ffffff;
  height: 0px;
  margin: 6px 12px 0;
}

.little-title-with-lines-title {
  color: #44ff99;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 6px;
  font-weight: 400;
  margin-bottom: 12px;
}
</style>
